<template lang="html">
  <div class="post-images-block">
    <div class="post-images-block-desc set-after">
      <label :for="'test' + images_block.id">Text</label>
      <textarea :name="'images_blocks[' + images_block.id + '][text]'" :id="'text' + images_block.id" cols="30" rows="5" class="long-input wysiwyg-please">{{ images_block.text }}</textarea>
    </div>
    <div class="post-images-block-images set-after">
      <label>Related images / videos (optional)</label>

      <post-image-inputs-list :prohibition='validation'
        :minId="images_block.id * 20"
        :idCoefficient="20000"
        :images="images_block.images"
        :videos="images_block.videos"
        @contentUploaded="prepareContentIds"
      ></post-image-inputs-list>
    </div>

    <input type="hidden" :name="'images_blocks[' + images_block.id + '][sorted_images_ids]'" v-model="imageIds">
    <input type="hidden" :name="'images_blocks[' + images_block.id + '][sorted_video_ids]'" v-model="videoIds">
    <input type="hidden" :name="'images_blocks[' + images_block.id + '][images]'" :value="JSON.stringify(filteredImages)">

    <div class="col-full align-center" v-if="removeIsAvailable">
      <button :disabled="validation" type="button" class='transparent-button' @click="deleteImagesBlock">Delete section</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images_block', 'validation', 'blocksCount'],
  data() {
    return {
      imageIds: null,
      videoIds: null,

      filteredImages: [],
    };
  },
  computed:{
    removeIsAvailable: function(){
      return this.blocksCount != 1;
    }
  },
  methods: {
    prepareContentIds(input) {
      let filteredImages = window._.filter(input.content, (input) => {return input.type === 'image';});
      let filteredVideos = window._.filter(input.content, (input) => {return input.type === 'video';});

      this.imageIds = window._.compact(window._.map(filteredImages, 'imageId'));
      this.videoIds = window._.compact(window._.map(filteredVideos, 'videoId'));

      $(this.$el).find('.post-images-block-images .news-validation').remove();

      this.update(filteredImages);
    },

    deleteImagesBlock() {
      if (confirm('Are you sure you want to remove all content from this section?')) {
        this.$emit('imagesBlockDeleted', {
          id: this.images_block['id']
        });
      }
    },

    update(filteredImages) {
      let textEditor = CKEDITOR.instances[$(this.$el).find('.wysiwyg-please').attr('id')];

      this.$emit('imagesBlockUpdated', {
        id: this.images_block.id,
        sorted_images_ids: this.imageIds ? this.imageIds.join(',') : '',
        sorted_video_ids: this.videoIds ? this.videoIds.join(',') : '',
        text: textEditor ? textEditor.getData() : this.images_block.text,
        images: filteredImages ? filteredImages : [],
      });

      this.filteredImages = filteredImages ? filteredImages : [];
    }
  },

  mounted() {
    CKEDITOR.replace($(this.$el).find('.wysiwyg-please').attr('name'), {
      uiColor: '#dddddd'
    });

    CKEDITOR.instances[$(this.$el).find('.wysiwyg-please').attr('id')].on('change', () => {
      $(this.$el).find('.post-images-block-desc .news-validation').remove();

      this.update();
    });
  }
};
</script>